import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const oceanGreen = '#39BA7C'
const swansDown = '#D2EEE0'

const StyledLabel = styled.span`
  color: var(--silver-chalice);
  font-size: 14px;
  font-family: 'Roboto mono', monospace;
  margin-right: 8px;
`
const StyledCount = styled.span`
  display: inline-block;
  min-width: 72px;
  padding: 0 4px 0 16px;
  text-align: right;
  font-size: 14px;
  font-family: 'Roboto mono', monospace;
  color: ${oceanGreen};
  background-color: ${swansDown};
`
export const CounterMono = ({
  label,
  count,
  className,
  'data-mu-test': dataAttributeTest
}) => {
  return (
    <span className={className} data-mu-test={dataAttributeTest}>
      <StyledLabel>{label}</StyledLabel>
      <StyledCount>{count}</StyledCount>
    </span>
  )
}

CounterMono.propTypes = {
  label: PropTypes.string,
  count: PropTypes.string,
  className: PropTypes.string,
  'data-mu-test': PropTypes.string
}
